import { forwardRef } from 'react';
import { cn } from '../../lib/utils';

export const Textarea = forwardRef<
  HTMLTextAreaElement,
  React.TextareaHTMLAttributes<HTMLTextAreaElement>
>(({ className, ...props }, ref) => (
  <textarea
    ref={ref}
    className={cn(
      'w-full resize-none border border-line bg-surface px-4 py-3 text-[15px] text-ink outline-none',
      'placeholder:text-muted-2 focus:border-accent transition-colors duration-140',
      className,
    )}
    {...props}
  />
));
Textarea.displayName = 'Textarea';
